import SmoothScroll from 'smooth-scroll';
import Rellax from 'rellax';
import { transformHeaderOnScroll, toggleMobileMenu } from "./header.js"
import { joinRadio } from "./join.js"
import Plyr from 'plyr';

//Init Rellax
new Rellax('.rellax');

//Init SmoothScroll
new SmoothScroll('a[href*="#"], a.scroll, li.scroll', {
    header: '[data-scroll-header]'
});

const header = document.querySelector("header");
const threshold = 40;
const menuTrigger = document.querySelector('.hamburger');

//Init Header Scroll Animation Event
if (header && threshold) window.addEventListener('scroll', function () { transformHeaderOnScroll(header, threshold); } );

//Init Mobile Menu Event
if (menuTrigger && header) menuTrigger.addEventListener('click', function () { toggleMobileMenu(header, menuTrigger); });
joinRadio();

//Closes mobile menu when link with class scroll is clicked
if (document.querySelectorAll('.scroll')) {
    const scrollNav = document.querySelectorAll('.scroll a');
    scrollNav.forEach(function (nav) {
        nav.addEventListener("click", () => { 

            //If child submenu is active remove active class
            if (document.querySelectorAll('.menu-item-has-children.active')) {
                document.querySelectorAll('.menu-item-has-children.active').forEach(function (dropDown) {
                    dropDown.classList.remove('active');
                });
            }
            //If mobile menu is active toggle activeMenu and isActive classes
            if (header.classList.contains('activeMenu')) {
                header.classList.toggle('activeMenu');
                menuTrigger.classList.toggle('isActive');
            }
        });
    });
}

// Sub Menu for Mobile
let plusIcon = '<span class="dropIcon"><i class="fa fa-plus" aria-hidden="true"></i><i class="fa fa-minus" aria-hidden="true"></i></span>'

document.querySelectorAll('.menu-item-has-children a').forEach(function (menu) {
    if (menu.parentElement.classList.contains('menu-item-has-children')) {
        menu.insertAdjacentHTML('beforebegin', plusIcon);
    }
});

document.querySelectorAll('.dropIcon').forEach(function (icon) {
    icon.addEventListener("click", () => {
        if (icon.parentElement.classList.contains('active')) {
            icon.parentElement.classList.remove('active');
        } else {
            icon.parentElement.classList.add('active');
        }
    });
});

//global video player plugin
window.addEventListener('DOMContentLoaded', () => {
	const players = Array.from(document.querySelectorAll('.js-player')).map((p) => new Plyr(p, {
		clickToPlay: true,
		poster: p.dataset.plyrPoster,
		controls: ['play-large'],
		youtube: {
			noCookie: false
		},
		fullscreen: {
			enabled: true,
			fallback: true,
			iosNative: true
		}
	}));
	players.forEach((player) => {
		player.on('ended', function () {
			player.stop();
		});
	});
});